import cx from "classnames";

export default function ReactionPills({
  reactions,
  unreact = (e) => {},
  react = (emoji) => {},
}) {
  return (
    <div className="flex">
      {reactions.details.map((reaction, index) => (
        <button
          key={reaction.emoji}
          className={cx(
            "mr-2 flex items-center rounded px-1 text-xs text-secondary-foreground",
            {
              "bg-primary-light": reaction.isByMe,
              "bg-muted-foreground": !reaction.isByMe,
            }
          )}
          style={{
            height: "21px",
          }}
          onClick={(e) => {
            // set reaction as this emoji
            if (reaction.isByMe) {
              unreact();
            } else {
              react(reaction.emoji);
            }
            // hit like api
          }}
          title={
            "Reacted by " + reaction.users?.map((user) => user.name).join(", ")
          }>
          <span className="pr-1">{reaction.emoji}</span>
          <span className="pl-1">{reaction.count}</span>
        </button>
      ))}
    </div>
  );
}
